module.exports = __webpack_public_path__ + "media/images/pages/img_cover_right_05-f651d40ff92585bc8a270875e0d0d04b.jpg";